export enum TradingAccountType {
  Pro = 1,
  Classic = 2,
  Raw = 3,
  VIP = 5,
}

export type TradingAccountTypeName = 'Pro' | 'VIP' | 'Classic' | 'Raw'

export interface IntroducingBrokerCommissionPlanGroupDto {
  id: string
  name: string
  commissionPlans: {
    amount: number
    tradingAccountType: { id: TradingAccountType; name: TradingAccountTypeName }
  }[]
  isDefault: boolean
}

interface RebateData {
  tradingAccountTypeId: number
  amount: number
  maxRebate: number
  currentAmount: number
}

export interface AddEditIntroducingBrokerCommissionPlanGroupDto {
  pro: RebateData
  vip: RebateData
  classic: RebateData
  raw: RebateData
}
